import { render, staticRenderFns } from "./SubsidioMotorCatalogo.vue?vue&type=template&id=87f5e034&"
import script from "./SubsidioMotorCatalogo.vue?vue&type=script&lang=js&"
export * from "./SubsidioMotorCatalogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports